setUserUsernameAvailabilityProcessing